import AddressSuggestionsSelector from 'components/AddressModal/components/AddressSuggestionsSelector/styled';

export default AddressSuggestionsSelector;
